// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found_container__Oi59F","link":"not-found_link__k20ud","title":"not-found_title__agJaP"};